import { Component } from '@angular/core';
import { User } from '../../../models/users/user';
import { UserService } from '../../../models/users/userService';
import {
  Page,
  TableViewAbstractComponent,
} from '../../ui/filterable-table/tableViewAbstractComponent';
import { StorageService } from '../../../core/storage/storageService';
import { IconType } from '../../../../../../../libs/Shared/components/icon/icon';

@Component({
  selector: 'app-user-table-view',
  templateUrl: './user-table-view.component.html',
  standalone: false,
})
export class UserTableViewComponent extends TableViewAbstractComponent {
  allowImpersonate: boolean = false;
  allowEditusers: boolean = false;
  impersonationNotAllowedReason: string = '';
  IconType = IconType;
  loading = true;

  constructor(
    public userService: UserService,
    public storage: StorageService,
  ) {
    super();
  }

  ngOnInit() {}

  getRecordFromDataSource(userId: string): User {
    for (var i = 0; i < this.dataSource.data.length; i++) {
      if (this.dataSource.data[i].id == userId) {
        return this.dataSource.data[i];
      }
    }

    throw 'User not found in dataset';
  }

  getPageOfData(
    query: string,
    filters: any[],
    pageNum: number,
    pageSize: number,
    sortColumn: string,
    sortDirection: string,
  ): Promise<Page<User>> {
    this.allowEditusers = this.options.allowEditing ?? false;
    this.allowImpersonate = this.options.allowImpersonation ?? false;

    if (!this.allowImpersonate) {
      this.impersonationNotAllowedReason =
        'You do not have permission to impersonate users.';
    } else if (
      this.allowImpersonate &&
      this.storage.getImpersonatingUser() != null
    ) {
      this.allowImpersonate = false;
      this.impersonationNotAllowedReason =
        'You cannot impersonate a user while impersonating another user.';
    }

    if (this.options.isAdmin == true) {
      return this.userService.getPagedAdmin(query, pageNum, pageSize).finally(() => this.loading = false);
    } else {
      return this.userService.getPaged(
        this.options.accountId,
        this.options.merchantId,
        query,
        pageNum,
        pageSize,
        'last_name',
        sortColumn,
        sortDirection,
      ).finally(() => this.loading = false);
    }
  }

  canQuery(): boolean {
    return this.options.allowEditing != undefined;
  }

  btnManageAccount_click(id: string) {
    this.selectedRecord.emit(id);
  }

  merchantSignIn_click(id: string) {}

  userIsSelf(id: string): boolean {
    return id == this.storage.getCurrentUser()?.id;
  }

  filterByLetter_click(letter: string) {}

  impersonateUser(userId: string) {
    this.userService.impersonateUser(userId);
  }

  _selectRow_click(id: string) {
    if (this.options.selectAction != 'none') {
      this.selectRow_click(id);
    }
  }
}
